import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PageWrapper = styled.div`
    flex-direction: column;
    width: 100%;
    overflow: hidden;
`;

export const SectionTitle = styled.h2`
    ${FONTS.H1};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H2};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H3};
    }
`;
